import { usePaywallContext } from '@/features/subscriptions/context/paywall-context';
import { useOrgSubscription } from '@/features/subscriptions/hooks/use-org-subscription';
import {
  getPaywallContext,
  isPaywallError,
} from '@/features/subscriptions/utils/paywall-error-codes';
import { handleError } from '@/shared/utils/error-handling';

export function usePaywall() {
  const { isOpen, context, projectId, openPaywall, closePaywall } =
    usePaywallContext();
  const { data: orgSubscription } = useOrgSubscription();

  function openProjectPaywall(projectId?: number) {
    if (!orgSubscription?.subscription) {
      openOrganizationPaywall();
      return;
    }
    openPaywall('project', projectId);
  }

  function openOrganizationPaywall() {
    openPaywall('organization');
  }

  function openAddonPaywall(projectId?: number) {
    openPaywall('addon', projectId);
  }

  async function handleErrorIfPaywallErr(error: unknown, projectId?: number) {
    const errorCode = await handleError(error);
    if (isPaywallError(errorCode)) {
      const context = getPaywallContext(errorCode);
      if (!orgSubscription?.subscription) {
        openOrganizationPaywall();
      } else {
        openPaywall(context, projectId);
      }
      return true;
    }
    return false;
  }

  return {
    isOpen,
    context,
    projectId,
    openProjectPaywall,
    openOrganizationPaywall,
    openAddonPaywall,
    closePaywall,
    openPaywallFromError: handleErrorIfPaywallErr,
  };
}
